export default __webpack_public_path__ + "static/media/H0000.aa360c1a.png";